import { configureStore as configureReduxStore } from '@reduxjs/toolkit';
import { bundlesApiMiddleware } from '../middleware/bundlesApi';
import { productConfigurationsToQueryMiddleware } from '../middleware/productConfigurationsToQuery';
import { removeIneligibleAddOnsMiddleware } from '../middleware/removeIneligibleAddOns';
import { sortProductConfigurationsMiddleware } from '../middleware/sortedProductConfigurations';
import { rootReducer } from '../reducers';
const customMiddleware = [bundlesApiMiddleware, removeIneligibleAddOnsMiddleware, sortProductConfigurationsMiddleware, productConfigurationsToQueryMiddleware];
export default function configureStore(initialState = {}) {
  return configureReduxStore({
    preloadedState: initialState,
    reducer: rootReducer,
    middleware: getDefaultMiddleware =>
    // thunk is included by default
    getDefaultMiddleware({
      immutableCheck: {
        warnAfter: 100 // ms
      }
    }).concat(customMiddleware),
    devTools: {
      name: 'pricing-pages-ui'
    }
  });
}